// extracted by mini-css-extract-plugin
module.exports = {"base":"OrgProductDetails_base__3ygOk","unit":"OrgProductDetails_unit__1_1nh","unit2":"OrgProductDetails_unit2__3eJ4Z"};